var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDisplayLargeCustomPaintRoller = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h80v80H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.443 16.872h-2.01v-4.679A4.999 4.999 0 0 0 56.438 7.2H17.05a4.999 4.999 0 0 0-4.993 4.993v12.462a4.999 4.999 0 0 0 4.993 4.993h39.39a4.999 4.999 0 0 0 4.993-4.993v-5.191h2.01c.904 0 1.638.732 1.638 1.633V34.17c0 .9-.734 1.633-1.637 1.633H36.744c-.715 0-1.296.58-1.296 1.296v6.852h-3.615c-.716 0-1.296.58-1.296 1.296v24.247a4.065 4.065 0 0 0 4.06 4.06h4.294a4.065 4.065 0 0 0 4.06-4.06V45.248c0-.715-.58-1.296-1.296-1.296H38.04v-5.556h25.403a4.232 4.232 0 0 0 4.23-4.225V21.097a4.232 4.232 0 0 0-4.23-4.225zm-4.603 7.783a2.404 2.404 0 0 1-2.4 2.401H17.05a2.404 2.404 0 0 1-2.402-2.401V12.193a2.404 2.404 0 0 1 2.401-2.401h39.39a2.404 2.404 0 0 1 2.401 2.401v12.462zm-18.48 44.84a1.47 1.47 0 0 1-1.469 1.468h-4.294a1.47 1.47 0 0 1-1.468-1.468v-22.95h7.23v22.95z",
    fill: "#9A5238",
    fillRule: "nonzero"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDisplayLargeCustomPaintRoller);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/display-large-custom-paint-roller.69bc375aca0fab0ff030378a7397ffb5.svg";